import React from "react";
import { FaBookOpen } from "react-icons/fa";

const tuitionData = [
  { grade: "6th", description: "The CBSE aims to give students better learning facilities so that they rise and attain their career objective." },
  { grade: "7th", description: "The CBSE board designs unsurpassed educational programs for students, which certainly help them to excel." },
  { grade: "8th", description: "The CBSE board prepares syllabus with utmost precision so that students can acquire updated and informative knowledge." },
  { grade: "9th", description: "CBSE course for class 09 includes Mathematics, Science, Social Science, English, etc." },
  { grade: "10th", description: "CBSE course for class 10 includes Mathematics, Science, Social Science, English, etc." },
];

const CBSE = () => {
  return (
    <div className="min-h-screen  p-6">
      <div className="w-full max-w-screen-xl mx-auto">
        {/* Page Header */}
        <h1 className="text-4xl font-bold text-[#1ba6db] mb-6 text-center">
          CBSE - Central Board of Secondary Education
        </h1>
        <p className="text-lg text-gray-700 max-w-screen-lg mx-auto text-center mb-6">
          The Central Board of Secondary Education (CBSE) is a Board of Education for public and private schools, under the Union Government of India.
        </p>
        {/* Courses Information */} 
      

        {/* Tuition Details */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 mt-8">
          {tuitionData.map((tuition, index) => (
            <div key={index} className="max-w-sm bg-white shadow-[0px_0px_15px_rgba(0,0,0,0.09)] p-9 space-y-3 relative overflow-hidden">
              {/* Circle Badge */}
              <div className="w-24 h-24 bg-[#1ba6db] rounded-full absolute -right-5 -top-7 flex items-center justify-center">
                <p className="text-white text-2xl font-semibold">{tuition.grade}</p>
              </div>
              {/* React Icon */}
              <div className="text-[#1ba6db] text-4xl">
                <FaBookOpen />
              </div>
              {/* Heading */}
              <h1 className="font-bold text-xl">{tuition.grade} Tuition</h1>
              {/* Description */}
              <p className="text-sm text-zinc-500 leading-6">{tuition.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <h2 className="text-3xl font-semibold text-[#1ba6db] mb-4">Courses Info</h2>
          <p className="text-gray-800 text-lg leading-relaxed mb-4">
            Tuitions in Vellore for CBSE are provided by Kalamji Academy. We train students for their board exams with special strategies and techniques. Our expert tutors provide question paper patterns, important topics, and key questions to help students excel. We focus on concept clarity and effective learning methods to make education engaging and impactful.
          </p>
          <p className="text-gray-800 text-lg leading-relaxed mb-4">
            Kalamji Academy is well-known for Mathematics coaching. We simplify complex problems, making them easier to understand. Our unique teaching methods ensure students grasp each topic thoroughly. We also offer step-by-step problem-solving sessions, ensuring every student builds confidence and expertise.
          </p>
          
          <p className="text-gray-800 text-lg leading-relaxed">
            To help students excel, we provide customized study materials, including important questions and key concepts. Our approach makes learning enjoyable and productive, ensuring that students achieve their best performance in board exams. Kalamji Academy is one of the top tuition centers for 10th and 12th standard students in Vellore.
          </p>
        </div>
      </div>

    </div>
  );
};

export default CBSE;
